module.exports = __webpack_public_path__ + "img/logo2.fbe4a530.png";